module.exports = __webpack_public_path__ + "img/circle_play.2b2ff058.png";